import createReactComponent from '../createReactComponent';
import { IconNode } from '../types';

export const __iconNode: IconNode = [["path",{"d":"M3 9a2 2 0 0 1 2 -2h14a2 2 0 0 1 2 2v9a2 2 0 0 1 -2 2h-14a2 2 0 0 1 -2 -2v-9","key":"svg-0"}],["path",{"d":"M8 7v-2a2 2 0 0 1 2 -2h4a2 2 0 0 1 2 2v2","key":"svg-1"}]]

const IconBriefcase2 = createReactComponent('outline', 'briefcase-2', 'Briefcase2', __iconNode);

export default IconBriefcase2;